import { getItems } from './getItems';
import type { CacheItem } from '../store/schema/CacheItem';
import type { CacheDescriptor } from '../store/schema/CacheDescriptor';
import type { ItemCache } from '../store/schema/ItemCache';

export function getItemIds<T extends CacheItem, U extends CacheDescriptor>(
    store: ItemCache<T, U>,
    filter: U,
    buildDescriptorFilter: (descriptor: U) => (item: T) => boolean,
    containsDescriptor: (descriptor1: U, descriptor2: U) => boolean
): string[] | undefined {
    const tasks = getItems<T, U>(store, filter, buildDescriptorFilter, containsDescriptor);
    return tasks ? tasks.map(item => item.Id) : undefined;
}
